var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"id":"View.vue"}},[_c('router-view',{staticClass:"router__main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }